import React from 'react';
import Checkbox from '../../Inputs/Checkbox/Checkbox';
import CheckboxWrap from '../../Ui/CheckboxWrap';
import SelectAllControl from "../SelectAllControl";

const CheckboxListSelector = (props: {
  values: Array<string>;
  options: Array<string>;
  name: string;
  onChange: (values: Array<string>) => void;
}) => {
  const { values, options, name, onChange } = props;

  const onCheckboxChange = (value: string, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  };

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <CheckboxWrap>
        {
          options.map(option =>
            <Checkbox
              key={option}
              label={option}
              value={option}
              checked={values.includes(option)}
              name={name}
              onChange={(checked) => onCheckboxChange(option, checked)}
            />)
        }
      </CheckboxWrap>
    </div>
  );
};

export default CheckboxListSelector;
